export const structureFilterReducerKey = 'structureFilter';

export const setDrawingType = 'SET_DRAWING_TYPE';

export const structureOptionId = 'structureOptionId';

